<template lang="pug">
  v-container.pt-1(grid-list-md='' text-xs-left='')
    v-card(tile='')
        v-toolbar(card='' dark='' flat='' :color='colors.info' height='60')
            v-toolbar-title Retiro Cheques
                v-icon web
            v-spacer
        v-card-text
          v-data-table.elevation-1(v-model='selected' :headers='headers' :items='listCheck' :pagination.sync='pagination' select-all='' item-key='id' :loading='loadingTable' no-data-text="Sin Cheques Registrados" rows-per-page-text="Filas por pagina")
            template(slot='headers' slot-scope='props')
              tr
                th
                  v-checkbox(:input-value='props.all' :indeterminate='props.indeterminate' primary='' hide-details='' @click.native='toggleAll')
                th(v-for='header in props.headers' :key='header.text' :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']" @click='changeSort(header.value)')
                  v-icon(small='') arrow_upward
                  |             {{ header.text }}
            template(slot='items' slot-scope='props')
              tr(:active='props.selected' @click='props.selected = !props.selected')
                td
                  v-checkbox(:input-value='props.selected' primary='' hide-details='')
                
                td {{ props.item.account_number }}
                td.text-xs-left {{ props.item.bank }}
                td.text-xs-left {{ props.item.serial_number }}
                td.text-xs-left {{ props.item.type }}
                td.text-xs-left {{ props.item.status }}
                td.text-xs-left $ {{ props.item.amount | mixThousandSeparatorFormat}}
        v-card-actions
          
          v-btn(flat :color='colors.info' @click="cleanSelected") Limpiar
          v-btn( :color='colors.info' dark @click="retireCheck") Retirar cheques

</template>

<script>
import checkService from '@/services/API/Check/CheckService.js'
import { mapState, mapActions } from 'vuex'
import TextFormatting from '@/mixins/reusable_mixins/TextFormatting'
export default {
    name: 'retire-bank-check',
    // props: {},
    data: function() {
        return {
            pagination: {
                sortBy: 'name',
            },
            selected: [],
            headers: [
                { text: 'N° Cuenta', value: 'account_number', align: 'left' },
                { text: 'Banco', value: 'bank', align: 'left' },
                { text: 'N° Serie', value: 'serial_number', align: 'left' },
                { text: 'Tipo', value: 'type', align: 'left' },
                { text: 'Estado', value: 'status', align: 'left' },
                { text: 'Monto', value: 'amount', align: 'left' },
            ],
            //jano work
			listCheck: [],
			loadingTable: false,
        }
    },
    computed: {
        ...mapState('AuthModule', {
            cash_desk_id: 'cash_desk_id',
            cash_desk_token: 'cash_desk_token',
            user: 'user',
        }),
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    methods: {
		/*
		 */
        toggleAll() {
            if (this.selected.length) this.selected = []
            else this.selected = this.listCheck.slice()
		},
		/*
		 */
        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending
            } else {
                this.pagination.sortBy = column
                this.pagination.descending = false
            }
		},
		cleanSelected(){
			this.selected = []
		},
        /*
         */
        async fetchCheckList() {
            const payload = {
                pos_cash_desk_id: this.cash_desk_id,
                g_cashier_user_id: this.user.id,
            }
            return await checkService.getChecks(payload)
        },
        /*
         */
        setListCheck(list) {
            this.listCheck = list
        },
        /*
         */
        formatCheckData(data) {
            return data.map(r => {
                //console.log(r,'r')
                let newObj = { ...r }
                newObj.status = r.sl_check_status.status
                newObj.bank = r.g_bank.bank
                newObj.type = r.pos_payment_check_type.type
                return newObj
            })
        },

        /*
         */
        async initComponent() {
			this.loadingTable = true
			let response = await this.fetchCheckList()
			this.loadingTable = false
			if(response.data){
				this.setListCheck(this.formatCheckData(response.data))
			}
			
        },
        /*
         */
        retireCheck() {
            this.resetSnackbarState()
            if (this.selected.length > 0) {
                this.setMessageConfirmSnack('retirar')
                let payload = {
                    typeMessage: 'info',
                    message: {
                        title: '¿Deseas retirar cheques seleccionados?',
                        body:
                            'Una vez retirados , los cheques seleccionados no apareceran',
                    },
                    timeout: 10000,
                    showProgress: false,
                    showCloseBtn: true,
                    closeBtnMessage: 'cerrar',
                }
                this.initSnackbar(payload)
            } else {
                let payload = {
                    typeMessage: 'warning',
                    message: {
                        title: 'Sin cheque(s) seleccionado(s)',
                        body:
                            'Para realizar la acción debe primero seleccionar al menos un cheque',
                    },
                    timeout: 10000,
                    showProgress: false,
                    showCloseBtn: true,
                    closeBtnMessage: 'cerrar',
                }
                this.initSnackbar(payload)
            }
        },
        /*
         */
        submitAllCheck() {
			let arrCheckPromises = []
			this.loadingTable = true
            this.selected.forEach(check => {
                arrCheckPromises.push(this.submitCheck(check.id))
            })

            Promise.all(arrCheckPromises)
                .then(r => {
                    console.log(r, 'r sumitallcheck')
					this.successMessage()
					this.initComponent()
                })
                .catch(e => {
                    console.log(e, 'error')
                    this.errorMessage()
				})
			this.loadingTable = false
        },
        successMessage() {
            this.resetSnackbarState()
            let payload = {
                typeMessage: 'success',
                message: {
                    title: 'Éxito',
                    body:
                        'Los cheques retirados fueron registrados exitosamente',
                },
                timeout: 10000,
                showProgress: false,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            }
            this.initSnackbar(payload)
		},
		/*
		 */
		errorMessage(error) {
			this.resetSnackbarState()
            let payload = {
                typeMessage: 'error',
                message: {
                    title: 'Error',
                    body:error,
                },
                timeout: 10000,
                showProgress: false,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            }
            this.initSnackbar(payload)
		},
        /*
         */
        submitCheck(id) {
            return checkService.retireCheck(id)
        },
        /*
         */
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    watch: {
        responseConfirm: function(val) {
            if (val == 'retirar') {
                this.submitAllCheck()
            }
        },
    },
    // components: {},
    mixins: [TextFormatting],
    // filters: {},
    // -- Lifecycle Methods
    beforeMount() {
        this.initComponent()
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss"></style>
